import { type UploadFile } from "antd"
import React from "react"

import { type Attachment } from "../../../../../Album/types/attachment.types.ts"
import { ProjectFileCard } from "../../ProjectFileCard.tsx"
import { ProjectViewAlbumAttachmentsUpload } from "./ProjectViewAlbumAttachmentsUpload.tsx"

interface ProjectViewAlbumAttachmentsProps {
  fileList: UploadFile<Attachment>[]
  deletingIds: Set<string>
  addFilesAllowed: boolean
  currentUserId: string
  deleteAllowed: boolean
  deleteForeignAllowed: boolean
  editAllowed: boolean
  editForeignAllowed: boolean
  onRemoveAttachment: (id: string) => Promise<void>
  onRename: (attachmentId: string, nextFileName: string) => Promise<void>
  onPreviewFile: (file: UploadFile) => void
  onBeforeUpload?: (file: File) => boolean
  // onCancelUpload?: (uid: string) => void
}

export const ProjectViewAlbumAttachments = ({
  currentUserId,
  fileList,
  deletingIds,
  addFilesAllowed,
  deleteForeignAllowed,
  deleteAllowed,
  editAllowed,
  editForeignAllowed,
  onRemoveAttachment,
  onRename,
  onPreviewFile,
  onBeforeUpload
  // onCancelUpload
}: ProjectViewAlbumAttachmentsProps) => {
  return (
    <>
      {addFilesAllowed && (
        <ProjectViewAlbumAttachmentsUpload onBeforeUpload={onBeforeUpload} />
      )}

      {/* File Cards */}
      {fileList?.map((file) => (
        <div key={file.uid} className={"min-h-64"}>
          <ProjectFileCard
            currentUserId={currentUserId}
            file={file}
            deleteAllowed={deleteAllowed}
            deleteForeignAllowed={deleteForeignAllowed}
            editAllowed={editAllowed}
            editForeignAllowed={editForeignAllowed}
            deleting={deletingIds.has(file.uid)}
            onPreviewFile={onPreviewFile}
            onDelete={onRemoveAttachment}
            onRename={onRename}
            // onCancelUpload={onCancelUpload}
          />
        </div>
      ))}
    </>
  )
}
